var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Experience',{staticClass:"resume-container",attrs:{"userInfo":_vm.userInfo,"newList1":_vm.newList1,"newList2":_vm.newList2,"newList3":_vm.newList3,"newList4":_vm.newList4,"newList5":_vm.newList5,"newList6":_vm.newList6}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }